export default "__VITE_ASSET__c15502c4__"